export const ieo = {
  zzjx: 'Em andamento',
  rgjl: 'Registro de assinatura',
  yjjs: 'Acabou',
  sf: 'primeiro lançamento',
  mjze: 'Total',
  ckjz: 'Progresso',
  tips_1: 'Lançada a plataforma Biking Startup, vamos descobrir o código da riqueza com Biking! ',
  tips_2: 'Projetos de alta qualidade serão lançados em breve, aguardamos ansiosamente',
  jyjjks: 'Prestes a começar',
  ksjy: 'Começar',
  qjy: 'Ir para negociar',
  xmmc: 'Nome do projeto',
  xmfjs: 'Introdução à festa do projeto',
  syxm: 'Todos os projetos',
  banner_1: 'Plataforma de lançamento de projeto blockchain recém-lançada',
  banner_2: 'Bicicleta procura o azarão do blockchain juntos e abre o caminho para a liberdade de riqueza',
  ywc: 'Concluído',
  rgsj: 'Tempo de assinatura:',
  zcz: 'Apoiador',
  dqjd: 'Progresso atual',
  yck: 'Levantado',
  sddb: 'Token recebido',
  dff: 'A ser emitido',
  zwxm: 'Nenhum projeto ainda',
  xq: 'Detalhes',
  wksyr: 'Pré-aquecimento não iniciado',
  yrz: 'Aquecendo',
  jxz: 'Em andamento',
  yjs: 'Terminado',
  ts: 'Avisar',
  dbwfjy: 'Este token está temporariamente indisponível para negociação',
  ckqtdb: 'Por favor, verifique outros tokens',
  xm: 'Projeto',
  ksrg: 'Inscrição',
  yrg: 'Subscrito',
  xmjs: 'Introdução ao projeto',
  csjg: 'Preço inicial',
  dbzl: 'Símbolo total: {amount} peças',
  cssz: 'Valor de mercado: {fdv} dólar',
  xmcytj: 'Condições de participação no projeto',
  cjygzh: 'Crie uma conta de bicicleta',
  yyzh: 'Já tem uma conta, faça login diretamente',
  dlzhjkcy: 'Faça login em sua conta para participar da assinatura',
  dljkrg: 'Faça login em sua conta para se inscrever',
  xhzc: 'Ativos spot',
  zcdy: 'Ativos à vista ≥ 10 USDT',
  rggz: 'Regras de assinatura',
  rgcg: 'Assinatura bem-sucedida',
  cgrgxm: 'Parabéns! Você se inscreveu no projeto com sucesso! ',
  fhsy: 'Voltar à página inicial',
  cyrghd: 'Participe da atividade de assinatura do Biking Startup',
  rgje: 'valor da assinatura',
  xhzcgz: 'Avaliação de ativos à vista',
  rgsm: 'Descrição da assinatura:',
  rgsm1: '1. O valor da assinatura individual é ≥{amount1}USDT; ≤{amount2}USDT;',
  rgsm2: "2. O projeto aloca assinaturas em proporções iguais de acordo com o índice de investimento de capital. Se o usuário assinar tokens com valor superior ao valor real alocado, após a conclusão da assinatura, o U restante será devolvido ao dinheiro conta",
  qd: 'Sure',
  dir: 'para ser pré-aquecido',
  rgdjs: 'Inscrição contagem',
  yrdjs: "Pré-aquecer contagem",
  jykqdjs: 'Transação aberta contagem',
  qrg: 'Vá para se inscrever',
  rgjebdy: 'O valor da assinatura é de pelo menos {amount} USDT',
  rgjebgy: 'O valor máximo da assinatura não deve exceder {amount} USDT',
  rgjeccdqjc: 'O valor da assinatura excede o valor do ativo circulante',
  fxts1: "1. Os projetos iniciais ainda estão em sua infância e podem haver grandes riscos na operação do projeto, na tecnologia subjacente do projeto, no ambiente legal e regulatório, etc.",
  fxts2: "2. Compreender os Tokens e avaliar seus riscos inerentes requer conhecimento técnico e financeiro avançado.",
  fxts3: "3. Afetado pela tecnologia, leis e regulamentos, mercado e outros fatores, o preço do Token que você comprou pode flutuar violentamente e o preço pode diminuir ou aumentar significativamente.",
  fxts4: "4. Devido à tecnologia subjacente do Token ou da plataforma de negociação BIKING, o Token que você comprou não pode ser retirado total ou parcialmente.",
  sfpt: "Plataforma de lançamento de projeto Blockchain",
  xmhzsq: "Cooperação",
  hdlx: "Tipo",
  yryq: "um sinal",
  yrdq: "Múltiplas assinaturas",
  hdjg: "Preço",
  hdsl: "Quantidade",
  zqs: "Número total",
  rgqs: "Número de tickets de assinatura",
  rgsl: "quantidade de assinaturas",
  mqsl: "Quantidade por assinatura",
  mrzgqs: "Maior número de assinaturas",
  qian: "sinal",
  lian: "corrente",
  hdrgsm: "Instruções de assinatura: Depois de ganhar na loteria, o número total de usuários vencedores será selecionado aleatoriamente com base em todos os usuários vencedores. Se a assinatura falhar, o USDT usado na assinatura com falha será devolvido quando o lançamento aéreo vencedor for emitido." ,
  jqqd: "Ansioso pelo resultado da vitória",
  dbffkjy: "Os tokens podem ser negociados após serem emitidos",
  dzjgb: "A ser anunciado",
  dzq: "Para ser vencido",
  ffzt: "Status de distribuição",
  dbff: "Emissão de tokens vencedores",
  yff: "Emitido",
  wzq: "Não estou ganhando",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/pt_BR.js